export default __webpack_public_path__ + "static/media/progress.daced28f.png";